import { gql } from "@apollo/client";

export const TERMINATE_WORKFLOW = gql`
  mutation terminateWorkflow($reason: String, $workflowId: String!) {
    terminateWorkflow(reason: $reason, workflowId: $workflowId)
  }
`;

export const RESTART_WORKFLOW = gql`
  mutation restartWorkflow($useLatestDefinitions: Boolean, $workflowId: String!) {
    restartWorkflow(useLatestDefinitions: $useLatestDefinitions, workflowId: $workflowId)
  }
`;

export const RETRY_WORKFLOW = gql`
  mutation retryWorkflow($workflowId: String!, $resumeSubworkflowTasks: Boolean) {
    retryWorkflow(workflowId: $workflowId, resumeSubworkflowTasks: $resumeSubworkflowTasks)
  }
`;

export const RESUME_WORKFLOW = gql`
  mutation resumeWorkflow($workflowId: String!) {
    resumeWorkflow(workflowId: $workflowId)
  }
`;

export const PAUSE_WORKFLOW = gql`
  mutation pauseWorkflow($workflowId: String!) {
    pauseWorkflow(workflowId: $workflowId)
  }
`;
